export default function updatePageNumberQueryParam(pageNumber) {
  /* new page is zero indexed but to make our page more SEO friendly we'll change
    it here from 0 to go to 2 instead of 1. That way we avoid changing it everywhere
    because the Search API uses zero indexed pages */
  const searchParams = new URLSearchParams(location.search);
  searchParams.set("page", pageNumber);
  const searchParamsToString =
    pageNumber === 1 ? "" : `?${searchParams.toString()}`;

  if (pageNumber === 1) {
    searchParams.delete("page");
    history.replaceState({}, "", location.pathname);
  } else {
    history.pushState(
      { page: pageNumber },
      document.title,
      `${searchParamsToString}`
    );
  }
}
